(function() {
    'use strict';

    angular.module('product')
        .controller('ProductOptionGroupUpdateController', ProductOptionGroupUpdateController);

    ProductOptionGroupUpdateController.$inject = ['$state', 'notificationSrvc', 'productOptionGroupDataSrvc', 'productOptionGroupMessagesConst', 'errorNotificationSrvc'];

    function ProductOptionGroupUpdateController($state, notificationSrvc, productOptionGroupDataSrvc, productOptionGroupMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name_pl: [],
            name_en: [],
            name_de: [],
            name_cpde: [],
            name_cpen: [],
            description: [],
            group_choice: [],
            determines_paper_type: [],
            hide_in_order: [],
            nonFieldErrors: []
        };
        self.groupData = {
            name_pl: '',
            name_en: '',
            name_de: '',
            name_cpde: '',
            name_cpen: '',
            description: '',
            group_choice: '',
            determines_paper_type: '',
            hide_in_order: '',
            select_from_list: ''
        };

        self.updateGroup = updateGroup;
        self.cleanErrors = cleanErrors;

        self.group_choices = [];

        activate();

        function activate() {
            getGroup();
            getGroupChoices();
        }

        function getGroup() {
            return productOptionGroupDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(function (response) {
                self.groupData = response;

                delete self.groupData.date_modified;
                delete self.groupData.date_added;
                delete self.groupData.last_modified_by;
                return response;
            });
        }

        function getGroupChoices() {
            return productOptionGroupDataSrvc.groupChoiceChoices()
                .$promise.then(function(response) {
                    self.group_choices = response;
                    return response;
                });
        }

        function updateGroup() {
            productOptionGroupDataSrvc.update({
                pk: self.groupData.pk
            }, self.groupData).$promise.then(
                function (response) {
                    notificationSrvc.notification("success", productOptionGroupMessagesConst.update);
                    $state.go('layout.productOptionGroup.list');
                },
                function (response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }

    }
})();
